import { PaymentMethod } from '../../../../shared/store/BaseColonistStoreProduct.ts';
import { ColonistCoinProduct } from '../../../../shared/store/ColonistCoinProduct.ts';
import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { getParameterByName } from '../ui_utils/ClientUtils.ts';
import { UICheckoutAjaxEndPoints } from './UICheckoutAjaxEndPoints.ts';
import { getLobbyImagePath, logError } from '../ui_utils/Utils.ts';
import { setElementInnerHTML, setElementOnClick } from '../ui_utils/DomUtils.ts';
import { ColonistOneTimePurchaseProduct } from '../../../../shared/store/ColonistOneTimePurchaseProduct.ts';
export class UICheckoutPageController {
    hideNonStripePayments() {
        if (!this.isMembershipProduct()) return;
        const labelPaypal = document.getElementById('label_paypal');
        labelPaypal.style.display = 'none';
        const labelAmazonPay = document.getElementById('label_amazon_pay');
        labelAmazonPay.style.display = 'none';
        const labelBitpay = document.getElementById('label_bitpay');
        labelBitpay.style.display = 'none';
        const labelOtherMethods = document.getElementById('label_other_methods');
        labelOtherMethods.style.display = 'none';
    }
    deactivatePaynowButton() {
        this.paynowButton.classList.add('inactive');
        setElementOnClick(this.paynowButton, ()=>undefined);
    }
    activatePaynowButton() {
        this.paynowButton.classList.remove('inactive');
        setElementOnClick(this.paynowButton, ()=>this.clickedPaynow());
    }
    static getStoreProduct() {
        const coinProductId = getParameterByName('product');
        if (coinProductId != null) {
            const coinProductIdNumber = Number(coinProductId);
            const colonistCoinProduct = ColonistCoinProduct.getPurchaseProduct(coinProductIdNumber);
            return colonistCoinProduct;
        }
        const membershipProductId = getParameterByName('membership');
        if (membershipProductId != null) {
            const membershipProductIdNumber = Number(membershipProductId);
            const membershipProduct = ColonistMembershipProduct.getMembershipProduct(membershipProductIdNumber);
            return membershipProduct;
        }
        const oneTimePurchaseProductId = getParameterByName('one-time-purchase');
        if (oneTimePurchaseProductId != null) {
            const oneTimePurchaseProductIdNumber = Number(oneTimePurchaseProductId);
            const oneTimePurchaseProduct = ColonistOneTimePurchaseProduct.getOneTimePurchaseProduct(oneTimePurchaseProductIdNumber);
            if (oneTimePurchaseProduct.isActive() == false) return undefined;
            return oneTimePurchaseProduct;
        }
        return undefined;
    }
    generateCheckoutItem() {
        if (this.isMembershipProduct()) {
            this.generateMembershipCheckoutText();
            return;
        }
        this.generateCoinCheckoutText();
    }
    generateMembershipCheckoutText() {
        const productMembership = this.product;
        if (productMembership.billedAnnually) {
            setElementInnerHTML(this.itemPrice, {
                key: 'strings:storePage.sections.membership.billing.yearlyPayment',
                options: {
                    amount: productMembership.getAnnualPrice()
                }
            });
        } else {
            setElementInnerHTML(this.itemPrice, {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: `$` + this.product.getDefaultPrice()
                }
            });
        }
        setElementInnerHTML(this.itemName, this.product.getProductName());
        this.generateMembershipRenewalCheckoutText();
        this.itemImage.src = getLobbyImagePath(this.product.lobbyImage);
    }
    generateCoinCheckoutText() {
        setElementInnerHTML(this.itemPrice, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: this.product.getDefaultPrice()
            }
        });
        setElementInnerHTML(this.itemName, this.product.getProductName());
        this.itemImage.src = getLobbyImagePath(this.product.lobbyImage);
    }
    generateMembershipRenewalCheckoutText() {
        const membershipRenewalInfoContainer = document.getElementById('membership-renewal-info');
        const renewalDateString = this.calculateMembershipRenewalDate();
        const text = {
            key: 'strings:storePage.checkout.membershipRenewalInfo',
            options: {
                date: renewalDateString
            }
        };
        setElementInnerHTML(membershipRenewalInfoContainer, text);
    }
    calculateMembershipRenewalDate() {
        const renewalDate = new Date();
        const productMembership = this.product;
        if (productMembership.billedAnnually) {
            renewalDate.setFullYear(renewalDate.getFullYear() + 1);
        } else {
            renewalDate.setMonth(renewalDate.getMonth() + 1);
        }
        return renewalDate.toLocaleDateString();
    }
    connectPaymentForm() {
        for (const button of this.radioButtons){
            setElementOnClick(button, ()=>this.activatePaynowButton());
        }
    }
    getSelectedPaymentMethod() {
        for (const button of this.radioButtons){
            if (!button.checked) continue;
            switch(button.id){
                case 'credit_debit':
                case 'google_pay':
                case 'apple_pay':
                    return PaymentMethod.Stripe;
                case 'paypal':
                case 'amazon_pay':
                case 'bitpay':
                case 'other_methods':
                    return PaymentMethod.Xsolla;
            }
        }
        logError('getSelectedPaymentMethod', [
            'Error wtf'
        ]);
        return PaymentMethod.Stripe;
    }
    isMembershipProduct() {
        const isMembershipProduct = this.product instanceof ColonistMembershipProduct;
        return isMembershipProduct;
    }
    clickedPaynow() {
        const selectedPaymentMethod = this.getSelectedPaymentMethod();
        if (selectedPaymentMethod == PaymentMethod.Stripe) {
            void UICheckoutAjaxEndPoints.executeStripeColonistProductPurchaseSession(this.product.storeProductType, this.product.type, this.product.itemQuantity);
        }
        if (selectedPaymentMethod == PaymentMethod.Xsolla) {
            void UICheckoutAjaxEndPoints.executeXsollaColonistCoinPurchaseSession(this.product.storeProductType, this.product.type);
        }
    }
    constructor(){
        this.paynowButton = document.getElementById('checkout_paynow_button');
        this.itemImage = document.getElementById('checkout_item_image');
        this.itemPrice = document.getElementById('checkout_item_price');
        this.itemName = document.getElementById('checkout_item_name');
        this.radioButtons = document.getElementsByName('payment_method');
        const storeProduct = UICheckoutPageController.getStoreProduct();
        if (storeProduct == null) {
            this.deactivatePaynowButton();
            return;
        }
        this.product = storeProduct;
        this.hideNonStripePayments();
        this.activatePaynowButton();
        this.generateCheckoutItem();
        this.connectPaymentForm();
    }
}
